/* eslint import/prefer-default-export: "off" */
const parseProviderName = name =>
  name
    .split('_')
    .map(el => el.charAt(0).toUpperCase() + el.substring(1))
    .join(' ');

export { parseProviderName };



// WEBPACK FOOTER //
// ./src/helpers/contact.js